import { serialize } from 'object-to-formdata'
import axiosForGigbaseBiz from '../config'
import { DataResponse } from '../response'
import {
  MpEmploymentJob,
  MpEmploymentJobPayload,
} from 'types/mp_employment_job'
const resource = 'mp_employment_job_change_logs'

export const requests = {
  create: async (jobId: string, params: MpEmploymentJobPayload) => {
    return await axiosForGigbaseBiz.post<DataResponse<MpEmploymentJob>>(
      resource,
      serialize({ ...{ job_id: jobId }, ...params }),
    )
  },
}
